import { useEntriesSumByTask } from '@features/time-logging/hooks/useEntrySums'
import { useWeekDates } from '@hooks/useWeekDates'
import { useWeekStartsOn } from '@hooks/useWeekStartsOn'
import { ReactNode } from 'react'

export const TaskTotalById = ({
  taskId,
  children,
}: {
  taskId: number
  children: (total: number) => ReactNode
}) => {
  const weekStartsOn = useWeekStartsOn()
  const { start, end } = useWeekDates({ weekStartsOn })
  const total = useEntriesSumByTask(taskId, start, end)

  return <>{children(total)}</>
}
